import React from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
import { Box, xcss } from '@atlaskit/primitives';
import FocusState, { useCloseOnEscapePress } from '@atlassian/eoc-focus-state';

import messages from '../../common/messages';
import { useHeartbeatsContext } from '../../controllers/providers/heartbeats';

import { Detail } from './detail';
import { Form } from './form';

const ColumnStyles = xcss({
	width: '100%',
	marginTop: 'space.400',
	marginLeft: 'auto',
	marginRight: 'auto',
});

const MiddleColumnMediumStyles = xcss({
	maxWidth: '705px',
});

const MiddleColumnLargeStyles = xcss({
	maxWidth: '994px',
});

const CrossButtonContainerStyles = xcss({
	position: 'absolute',
	left: '56px',
	top: 'space.400',
});

const WrapperStyles = xcss({
	position: 'relative',
	flex: '1 1 0',
	overflow: 'auto',
});

export const Focus = () => {
	const { formatMessage } = useIntl();
	const { focusState } = useHeartbeatsContext();

	useCloseOnEscapePress({
		onClose: focusState.close,
	});

	return (
		<FocusState isOpen={focusState.isOpen} returnFocusRef={focusState.returnRef}>
			<Box xcss={WrapperStyles}>
				{focusState.mode !== 'view' && (
					<Box xcss={CrossButtonContainerStyles}>
						<IconButton
							label={formatMessage(messages.closeFocusState)}
							appearance="subtle"
							icon={CrossIcon}
							onClick={focusState.close}
						/>
					</Box>
				)}
				<Box
					xcss={[
						ColumnStyles,
						focusState.mode !== 'view' ? MiddleColumnMediumStyles : MiddleColumnLargeStyles,
					]}
				>
					{(focusState.mode === 'create' ||
						focusState.mode === 'edit' ||
						focusState.mode === 'duplicate') && <Form data={focusState.data} />}
					{focusState.mode === 'view' && !!focusState.data && <Detail data={focusState.data} />}
				</Box>
			</Box>
		</FocusState>
	);
};
